
<style scoped>
  .option-item{
    width: 100px;
    height: 100px;
    border:1px solid red ;
    display: none;
  }
  #select-btn:hover .option-item{
    display: block;
  }
  .head_search_div{
	  border-left: none !important;
  }
  .btn{
	  border:0;
	  border-left: #000000 solid 1px !important;
	  border-right: #000000 solid 1px !important;
	  border-radius: none;
	  height: 30px;
    width: 125px;
    .el-button-group>.el-button:not(:last-child) {
      margin-right: -1px;
      width: calc(100% - 30px);
    }
  }
</style>
<template>
  <div class="header">
    <header class="head">
        <!-- 头部logo搜索 -->
        <div class="head_logo word flex_between">
            <i class="head_logoT" @click="home"><img src="@/assets/images/logoT.png" alt=""></i>
		
            <div class="head_search_div flex_between">
			<el-dropdown split-button  @command="handleClick" size="mini" class="btn">
				{{$t(`search.arr`)[searchType]}}
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item,index) in $t(`search.arr`)" :key="index" :command="index">{{item}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
                <input type="text" :placeholder="$t('header.key')" v-model="serchMsg" @focus="searchAll">
                <div class="head_search_a flex_center" @click="serchFn">
                    <img src="@/assets/images/screen.png" alt="">
                </div>
            </div>
            <div class="head_shopping flex_center" @click="shop">
                <i><img src="@/assets/images/shopping.png" alt=""></i>
                {{$t('header.sopC')}}<span class="head_shopping_num">{{num ? num:0}}</span>{{$t('header.goods')}}	
            </div>
        </div>
    </header>
  </div>
</template>

<script>
import '@/assets/css/header.css';

export default {
  name: 'header',
  data () {
    return {
      serchMsg:'',
      showLoginPop:false,
	  tabs: [],
	  title: this.$t(`search.arr`)[0],
	  searchType: 0,
	  num:0
    }
  },
  methods:{
	  home () {
		this.$router.push('/')  
	  },
	  // 获取购物车数量
	  getShopnum() {
		this.$post("/api/shop/car/list", {
			token : sessionStorage.getItem('token')
		}).then(res => {
			this.num = res.data;
		});  
	  },
	  handleClick(e) {
	  	this.searchType = e
	  },
    serchFn(){
      this.$emit('serchMsg',this.serchMsg);
    },
    shop(){
      let token = sessionStorage.getItem('token')
      if(token){ //登录了										
        this.$router.push('/shopcar')
        this.showLoginPop = false
      }else{
        this.showLoginPop = true
      }
      this.$emit('showLoginPop',this.showLoginPop)
    },
    searchAll(){
      this.$router.push(`/searchAll?id=${this.searchType}`)
    }
  },
  mounted(){
	  this.tabs = this.$t(`search.arr`)
	  if (sessionStorage.getItem('token')) {
		  	this.getShopnum()
	  }
  },
}
</script>





// WEBPACK FOOTER //
// src/components/assembly/Header.vue